import { gql } from "generated-graphql";

export const DOCUMENT_METADATA_FACILITY_FRAGMENT = gql(`
  fragment DocumentMetadataFacility on Facility {
    id
    name
    customerFacilityId
    streetAddress1
    streetAddress2
    city
    state
    zip
  }
`);

export const DOCUMENT_WITH_METADATA = gql(`
  query DocumentWithMetadata($id: ID!) {
    document(id: $id) {
      id
      tenantId
      title
      description
      storageLink
      downloadLink
      documentType
      authoredAt
      fileExtension
      isArchived
      originalTitle
      originalDocumentType
      tasks {
        id
        seriesId
        tenantId
        title
        description
        frequency
        interval
        status
        startDate
        completedAt
        reminderDays
        assignee {
          id
          email
          person {
            first
            last
          }
        }
        subtasks {
          id
          title
        }
        facilities {
          id
        }
        watchers {
          id
          email
          person {
            first
            last
          }
        }
        documents {
          id
          fileExtension
          title
          documentType
        }
        taskTags {
          id
          tag {
            id
            name
          }
        }
        links
      }
      sourceWasteManifest {
        id
      }
      extractionStatus
      extractionError
      facilities {
        ...DocumentMetadataFacility
      }
      documentTags {
        id
        name
        type
      }
      documentMetadata {
        id
        documentId
        documentType
        documentSubtype
        documentNumber
        relatedDocumentNumber
        revisionNumber
        reportingPeriod
        siteName
        siteAddressLine1
        siteAddressLine2
        siteCity
        siteState
        siteZipCode
        siteEmail
        mailingName
        mailingAddressLine1
        mailingAddressLine2
        mailingCity
        mailingState
        mailingZipCode
        mailingEmail
        contactName
        contactEmail
        contactPhone
        contactAddressLine1
        contactAddressLine2
        contactCity
        contactState
        contactZipCode
        agency
        programArea
        regulatoryProgram
        regulatoryCitations
        regulatoryAuthority
        issueDate
        expirationDate
        effectiveDate
        submissionDeadline
        dueDate
        amount
        currency
        relatedDocumentIds
        supersedes
        summary
        keywords
        needsReview
        reviewedAt
        reviewedBy
      }
    }
  }
`);

export const DOCUMENTS_BY_IDS = gql(`
  query ReviewDocumentMetadataDialogDocuments($search: String!, $pageSize: Int) {
    documents(search: $search, page: 0, pageSize: $pageSize) {
      items {
        id
        title
        documentType
        extractionStatus
        documentMetadata {
          needsReview
        }
      }
    }
  }
`);

export const FACILITY_MATCHES_FOR_DOCUMENTS = gql(`
  query FacilityMatchesForDocuments($documentIds: [ID!]!, $minSimilarity: Float, $limit: Int) {
    facilityMatchesForDocuments(documentIds: $documentIds, minSimilarity: $minSimilarity, limit: $limit) {
      documentId
      matches {
        facilityId
        score
        facility {
          ...DocumentMetadataFacility
        }
      }
    }
  }
`);

export const DOCUMENT_MANIFEST_DETAIL = gql(`
  query DocumentManifestDetailForReview($wasteManifestId: ID!) {
    documentManifestDetail(wasteManifestId: $wasteManifestId) {
      wasteManifest {
        id
        facility {
          id
          name
        }
        manifestTrackingNumber
        shippedDate
        receivedDate
        generatorId
        generatorName
        generatorMailStreet1
        generatorMailStreet2
        generatorMailCity
        generatorMailState
        generatorMailZip
        generatorTxStateWasteRegistrationId
        generatorSiteAddressSameAsMailing
        generatorLocationStreet1
        generatorLocationStreet2
        generatorLocationCity
        generatorLocationState
        generatorLocationZip
        desFacilityId
        desFacilityName
        desFacLocationStreet1
        desFacLocationCity
        desFacLocationState
        desFacLocationZip
        sourceDocument {
          documentMetadata {
            needsReview
          }
        }
      }
      wasteLines {
        wasteLineNumber
        dotHazardous
        dotIdNumberDescription
        dotPrintedInformation
        nonHazWasteDescription
        containerNumber
        containerTypeCode
        quantity
        qtyUnitOfMeasureCode
        managementMethodCode
        federalWasteCodes
        stateWasteCodes
      }
      wasteTransporters {
        transporterLineNumber
        transporterId
        transporterName
      }
      issues {
        ...issue
      }
    }
  }
`);

export const EDIT_DOCUMENT_MANIFEST = gql(`
  mutation EditDocumentManifestFromReview($wasteManifestId: ID!, $input: DocumentManifestEditInput!) {
    editDocumentManifest(wasteManifestId: $wasteManifestId, input: $input) {
      wasteManifest {
        id
        manifestTrackingNumber
      }
    }
  }
`);

export const UPSERT_DOCUMENT_WITH_METADATA = gql(`
  mutation UpsertDocumentWithMetadata(
    $id: ID!
    $document: DocumentInput2!
    $metadata: DocumentMetadataInput
    $associations: [DocumentAssociationsInput!]
    $removeAssociations: [DocumentAssociationsInput!]
  ) {
    upsertDocument(
      id: $id
      document: $document
      currentSubmissionDocument: false
      metadata: $metadata
      associations: $associations
      removeAssociations: $removeAssociations
    ) {
      id
      title
      documentType
      authoredAt
      documentMetadata {
        id
        documentId
        documentType
        documentSubtype
        documentNumber
        relatedDocumentNumber
        revisionNumber
        reportingPeriod
        siteName
        siteAddressLine1
        siteAddressLine2
        siteCity
        siteState
        siteZipCode
        siteEmail
        mailingName
        mailingAddressLine1
        mailingAddressLine2
        mailingCity
        mailingState
        mailingZipCode
        mailingEmail
        contactName
        contactEmail
        contactPhone
        contactAddressLine1
        contactAddressLine2
        contactCity
        contactState
        contactZipCode
        agency
        programArea
        regulatoryProgram
        regulatoryCitations
        regulatoryAuthority
        issueDate
        expirationDate
        effectiveDate
        submissionDeadline
        dueDate
        amount
        currency
        relatedDocumentIds
        supersedes
        summary
        keywords
        needsReview
        reviewedAt
        reviewedBy
      }
    }
  }
`);
